import { RouteRecordRaw } from "vue-router";

const sidebarName = "SidebarIssueMonitoring";

export const issueMonitoringRoutes: RouteRecordRaw[] = [
  {
    path: "/issue-monitoring",
    component: () => import("@/views/common/Home.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/samplingpoints",
    component: () => import("@/views/issueMonitoring/IssueSamplingPoint.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/list",
    component: () => import("@/views/issueMonitoring/IssueList.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/apiconf",
    component: () => import("@/views/issueMonitoring/ApiConf.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/apiconf/history",
    component: () => import("@/views/issueMonitoring/HistoryApiConf.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/notes",
    component: () => import("@/views/issueMonitoring/NotesList.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/ranges",
    component: () => import("@/views/issueMonitoring/IssueRangeEstimations.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
];
